

<h1 class="accent-background-element">Map</h1>

<google-map width="100%">

  @for (marker of markers; track marker) {
    <map-marker #markerLink="mapMarker"
      [position]="marker.position"
      [title]="marker.title"
    [options]="marker.options"  (mapClick)="openInfoWindow(markerLink, infoWindow,marker.title,marker.id,marker.city, marker.zipCode, marker.addressLine1)"></map-marker>
  }
  <map-info-window #infoWindow="mapInfoWindow">
    <p> <b>ID:</b>&nbsp;{{infoContent.id}}</p>
    <p> <b>Name:</b>&nbsp;{{infoContent.name}}</p>
    <p> <b>City:</b>&nbsp;{{infoContent.city}}</p>
    <p> <b>Zip Code:</b>&nbsp;{{infoContent.zipCode}}</p>
    <p> <b>Address line 1:</b>&nbsp;{{infoContent.addressLine1}}</p>
  </map-info-window>

</google-map>